import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fillTemplate = (template, { name, service }) => {
  let message = template;
  if (name) message = message.replace('{name}', name);
  if (service) message = message.replace('{service}', service);
  return message;
};

export const useSmsData = (onError) => {
  const [templates, setTemplates] = useState({});
  const [twilioConfigured, setTwilioConfigured] = useState(false);
  const [leads, setLeads] = useState([]);
  const [smsLogs, setSmsLogs] = useState([]);

  const fetchSmsLogs = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/sms/logs`);
      setSmsLogs(data.logs || []);
    } catch {
      onError('Could not load message history');
    }
  }, [onError]);

  useEffect(() => {
    axios.get(`${API}/sms/templates`)
      .then(({ data }) => {
        setTemplates(data.templates);
        setTwilioConfigured(data.twilio_configured);
      })
      .catch(() => onError('Could not load templates'));
    axios.get(`${API}/contacts`)
      .then(({ data }) => setLeads(data))
      .catch(() => onError('Could not load leads'));
    fetchSmsLogs();
  }, [fetchSmsLogs, onError]);

  const sendSms = (payload) => axios.post(`${API}/sms/send`, payload);

  return { templates, twilioConfigured, leads, smsLogs, fetchSmsLogs, sendSms };
};
